<template>
  <div class="my-wrap finance-wrap">
    <div class="withdraw-frame withdraw-m-frame">
      <div class="my-withdraw-mobile-package withdraw-mobile">
        <div class="mobile-frame">
          <div class="channel-text-n">
            {{ $t('Bao.select_withdrawal_method') }}
          </div>

          <!-- 上方選單 -->
          <div class="mobile-wallet-card">
            <div class="wallet-list" @click="$router.push('/deposit')">
              {{ $t('Bao.deposit') }}
            </div>
            <div class="wallet-list" @click="$router.push('/buy-cryptocurrency')">
              {{ $t('Bao.buy_cryptocurrency') }}
            </div>
            <div class="wallet-list-on">
              {{ $t('Bao.withdraw_menu') }}
            </div>
          </div>
          <div class="deposit-bg">
            <div class="bank-choice">
              <div
                v-if="availableWithdrawalTypes[2]"
                class="bank-electron"
                :class="{ active: isElectronActive }"
                @click="goNextStep(2, 'electron')"
              >
                <p>{{ $t('Bao.e_wallet') }}</p>
              </div>
              <div
                v-if="availableWithdrawalTypes[1]"
                class="bank-bank"
                :class="{ active: isBankActive }"
                @click="goNextStep(1, 'bank')"
              >
                <p>{{ $t('Bao.bank_card_2') }}</p>
              </div>
              <div
                v-if="availableWithdrawalTypes[3]"
                class="bank-bitcoin"
                :class="{ active: isBitcoinActive }"
                @click="goNextStep(3, 'bitcoin')"
              >
                <p>{{ $t('Bao.cryptocurrency_for_withdrawal') }}</p>
              </div>
            </div>
          </div>

          <!--  mb 選提款方式 -->
          <div class="slider-form withdraw-slider-form">
            <div class="slider">
              <form class="row-frame dep-form-frame gx-3 form-row-gap">
                <!-- mb 選錢包 -->
                <template v-if="withdrawType !== 3">
                  <div v-if="filteredWallets.length > 0" class="colu colu-12">
                    <label class="colu-12 for-label" for="ウォレット-mb">
                      {{ $t('Bao.withdrawal_wallet') }}
                    </label>
                    <select
                      id="ウォレット-mb"
                      v-model="selectedWalletKey"
                      class="for-select inpType icon-select"
                      @change="handleWalletChange"
                    >
                      <option
                        v-for="wallet in filteredWallets"
                        :key="wallet.key"
                        :value="wallet.key"
                      >
                        {{ getWalletName(wallet.wallet_type) }}
                      </option>
                    </select>
                  </div>
                  <div v-show="withdrawType !== 3" class="colu-12 fun-withdraw-bank">
                    <div class="row-frame">
                      <label class="colu-12 for-label" for="カード/口座-mb">{{ $t('Bao.card_or_address') }}</label>
                      <div class="colu colu-7 ">
                        <select
                          id="カード/口座-mb"
                          v-model="postForm.member_bank_id"
                          class="for-select inpType"
                          @change="selectBank"
                        >
                          <option :value="selectedBankName">
                            {{ selectedBankName }}
                          </option>
                          <template v-for="(bank, key) in myBanks">
                            <option
                              v-if="bank.bank_type === withdrawType"
                              :key="key"
                              :value="bank.id"
                            >
                              {{ bank.card_number }}
                            </option>
                          </template>
                        </select>
                      </div>

                      <div class="colu colu-5 fun-withdraw-bank">
                        <button class="btn button-style btn-creat" @click.prevent="$router.push('/user/bank')">
                          <img :src="$getThemeImagePath('add.svg')" alt="">{{ $t('Bao.new_bank_card_1') }}{{ $t('Bao.new_bank_card_2') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-if="withdrawType === 3">
                  <div class="colu colu-12 fun-withdraw-crypto">
                    <div class="colu-12 for-label" for="">
                      <span v-if="!isCryptoSelect && withdrawType === 3">
                        {{ $t('Bao.withdrawal_source') }}
                      </span>
                      <span v-else>
                        {{ $t('Bao.withdrawal_currency') }}
                      </span>
                    </div>
                    <div class="ch-crypto-form">
                      <div class="form-input-n2">
                        <div class="crypto-select-frame">
                          <div class="lang-select">
                            <button class="btn-select" @click.prevent="toggleDropdown">
                              <li v-if="selectedCoin && isCryptoSelect">
                                <img :src="$getThemeImagePath(`crypto-${selectedCoin.symbol.toLowerCase()}.svg`)" alt="">
                                <div class="affiliateWallet">
                                  <div class="coin">
                                    {{ selectedCoin.symbol }}
                                  </div>
                                  <div class="wallet">
                                    {{ selectedCoin.balance }}
                                  </div>
                                </div>
                              </li>
                              <li v-if="!isCryptoSelect && withdrawType === 3">
                                <img :src="getWalletImagePath(mainWallet)" alt="">
                                <div class="affiliateWallet">
                                  <div class="coin">
                                    {{ mainWallet.currency }}
                                  </div>
                                </div>
                              </li>
                            </button>
                            <div class="b" :class="{ active: isOpen }">
                              <ul class="crypto-list">
                                <li v-for="coin in coinList" :key="coin.coinId" @click="selectCrypto(coin)">
                                  <img :src="$getThemeImagePath(`crypto-${coin.symbol.toLowerCase()}.svg`)" alt="">
                                  <div class="affiliateWallet">
                                    <div class="coin">
                                      {{ coin.symbol }}
                                    </div>
                                    <div class="wallet">
                                      {{ coin.balance }}
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="colu colu-12 fun-withdraw-crypto">
                    <label class="colu-12 for-label" for="ネットワークを選択">
                      <span v-if="!isCryptoSelect && withdrawType === 3">
                        {{ $t('Bao.withdrawal_target') }}
                      </span>
                      <span v-else>
                        {{ $t('Bao.withdrawal_chain') }}
                      </span>
                    </label>

                    <select
                      id="ネットワークを選択-mb"
                      v-model="selectedChain"
                      class="for-select inpType icon-select"
                      @change="handleCryptoChange"
                    >
                      <option v-for="(chainObj, index) in chainList" :key="index" :value="chainObj">
                        {{ chainObj.chain }}
                      </option>
                    </select>
                  </div>
                </template>

                <div class="colu-12">
                  <div class="colu-12">
                    <label class="colu-12 for-label" for="出金額を入力してください-mb">
                      <span v-if="!isCryptoSelect && withdrawType === 3">
                        {{ $t('Bao.please_enter_purchase_amount') }}
                      </span>
                      <span v-else>
                        {{ $t('Bao.please_enter_withdrawal_amount') }}
                      </span>
                    </label>
                  </div>
                  <div class="row-frame">
                    <div class="colu colu-7">
                      <input
                        id="出金額を入力してください-mb"
                        v-model="postForm.amount"
                        :placeholder="$t('Bao.input_withdrawal_amount')"
                        class="for-input inpType"
                        autocomplete="off"
                        type="text"
                        @input="handleInput"
                        @keypress="onlyNumbers"
                      >
                    </div>

                    <div class="colu colu-5">
                      <button class="btn button-style btn-creat" @click.prevent="setAllAmount()">
                        {{ $t('Bao.withdrawal_all') }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="colu colu-12">
                  <template v-if="selectedBankTypeCode === 'JetonPay'">
                    <label class="colu-12 for-label" for="withdraw-amount">
                      {{ $t('Bao.jeton_account') }}
                    </label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.uid"
                        class="for-input inpType"
                        type="text"
                        :placeholder="$t('Bao.jeton_account')"
                        autocomplete="off"
                        @input="checkJetonErrors"
                      >
                    </div>
                    <div v-for="error in jetonErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                  </template>
                  <template v-if="selectedBankTypeCode === 'VegaWallet'">
                    <label class="colu-12 for-label" for="withdraw-amount">{{ $t('Bao.deposit_account') }}</label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.uid"
                        class="for-input inpType"
                        type="text"
                        :placeholder="$t('Bao.deposit_account')"
                        autocomplete="off"
                        @input="checkAccountErrors"
                      >
                    </div>
                    <div v-for="error in accountErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                    <label class="colu-12 for-label" for="withdraw-amount">
                      {{ $t('Bao.deposit_password') }}
                    </label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.password"
                        v-validate="'required'"
                        class="for-input inpType"
                        type="password"
                        name="password"
                        :placeholder="$t('Bao.deposit_password')"
                        autocomplete="off"
                      >
                    </div>
                    <div v-if="errors.has('password')" class="help-block">
                      {{ $t("Bao.deposit_password_error") }}
                    </div>
                  </template>

                  <div class="withdraw-detail-frame">
                    <div class="detailList">
                      <b class="wDtitle">{{ $t('Bao.withdraw_limit') }}</b>
                      <span class="wDamount">{{ withdrawalLimit }}</span>
                    </div>
                    <div class="detailList">
                      <b class="wDtitle">{{ $t('Bao.withdrawal_amount_tip_line_2') }}</b>
                      <span class="wDamount">
                        <template v-if="withdrawType !== 3 || (!isCryptoSelect && withdrawType === 3)">{{ brand.currency }} </template>
                        {{ amount_limit }}
                      </span>
                    </div>
                  </div>
                </div>

                <div v-if="withdrawType === 3" v-show="isCryptoSelect && withdrawType === 3" class="colu-12">
                  <label class="colu-12 for-label" for="withdraw-amount">
                    {{ $t('Bao.withdrawal_address') }}
                  </label>
                  <div class="wallet-amount-frame">
                    <input
                      v-model="postForm.address"
                      v-validate="'required'"
                      class="for-input inpType"
                      :class="{ 'isInvalid': errors.has('address') }"
                      type="text"
                      :placeholder="$t('Bao.withdrawal_address')"
                      autocomplete="off"
                      name="address"
                    >
                  </div>
                  <div v-if="errors.has('address')" class="input-feedback text-align-R">
                    {{ $t('Bao.wallet_address_error') }}
                  </div>
                </div>

                <div v-if="selectedChain && selectedChain.supportMemo" class="colu-12">
                  <label class="colu-12 for-label colu-mr-t" for="Destination Tag">{{ $t("Bao.destination_tag") }}</label>
                  <div class=" inp-relative">
                    <input
                      id="入金アドレス"
                      v-model="memo"
                      autocomplete="off"
                      class=" for-input inpType fs-14-w-700"
                      :placeholder="$t('Bao.destination_tag')"
                      type="text"
                    >
                    <button class="btn btn-keyChainCopy" @click.prevent="copyText(memo)" />
                  </div>
                  <div class="input-feedback remarks">
                    <div class="row-frame">
                      <div class="colu-auto icon-pr-1">
                        <i class="icon-alert ">
                          <img :src="$getThemeImagePath('icon_alert.png')" alt="">
                        </i>
                      </div>
                      <div class="colu-11 fs-14px pl-0 fs-remarks-box">
                        {{ $t("Bao.destination_tag_describe") }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="colu colu-12">
                  <template v-if="!google_auth_totp_status">
                    <label class="colu-12 for-label" for="inputPassword-mb">{{ $t("Bao.withdrawal_password") }}</label>
                    <input
                      id="inputPassword-mb"
                      v-model="postForm.withdrawal_pass"
                      class="for-input inpType"
                      type="password"
                      :placeholder="$t('Bao.withdrawal_password_default')"
                      autocomplete="off"
                    >
                  </template>
                  <template v-if="google_auth_totp_status">
                    <label class="colu-12 for-label" for="inputPassword-mb">{{ $t("Bao.google_auth_verification") }}</label>
                    <input
                      id="inputPassword-mb"
                      v-model="postForm.opt_code"
                      class="for-input inpType"
                      type="password"
                      :placeholder="$t('Bao.google_auth_default_verification')"
                      autocomplete="off"
                    >
                  </template>
                </div>

                <div class="colu colu-12 pb-2">
                  <div class="withdraw-detail-frame">
                    <div class="detailList">
                      <b class="wDtitle">
                        <span v-if="!isCryptoSelect && withdrawType === 3">
                          {{ purchaseCryptoText }}
                        </span>
                        <span v-else>
                          {{ $t('Bao.total_amount') }}
                        </span>
                      </b>
                      <span class="wDamount">
                        <template v-if="withdrawType !== 3">{{ brand.currency }} </template>
                        <span v-if="!isCryptoSelect && withdrawType === 3">
                          {{ transferValue }}
                        </span>
                        <span v-else>
                          {{ postForm.amount > 0 ? postForm.amount : 0 | numberFormat }}
                        </span>
                      </span>
                    </div>
                    <div class="detailList">
                      <b class="wDtitle">{{ $t('Bao.residual_bonus') }}</b>
                      <span class="wDamount">{{ brand.currency }} {{ bonusGold | numberFormat }}</span>
                    </div>
                  </div>
                </div>

                <div class="form-check">
                  <div class="checkbox-wrapper-40">
                    <label>
                      <input
                        id="CheckDefault-mb"
                        v-model="agree"
                        type="checkbox"
                        value=""
                      >
                      <span class="checkboxContent">
                        {{ $t('Bao.agree_delete_bonus_tips') }}
                      </span>
                    </label>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div
            class="button-style-w100 btn-primary"
            type="submit"
            :class="{ disabled: !checkInput() }"
            @click="!isCryptoSelect && withdrawType === 3 ? sendTransfer() : checkIsWithdraw()"
          >
            {{ $t('Bao.send') }}
          </div>

          <div v-if="isThemeGold" @click="$router.push('/page/support')">
            <a class="help-deposit-n">
              <span class="icon-help">?</span>
              <span class="help-text">{{ $t('Bao.withdrawal_description') }}</span>
            </a>
          </div>
        </div><!-- mb end -->
      </div>
      <div class="my-withdraw-frame">
        <div class="my-deposit my-d-box">
          <div class="channel-text-n">
            {{ $t('Bao.withdraw') }}<span>{{ $t('Bao.select_a_wallet') }}</span>
          </div>
          <div class="slider-form withdraw-container">
            <!-- pc 選提款方式-->
            <div class="my-wallet-out-frame2">
              <div
                v-if="availableWithdrawalTypes[2]"
                :class="{ 'channel-bank-cards-on': withdrawType === 2, 'channel-bank-cards': withdrawType !== 2 }"
                class="withdrawCF"
                @click="goNextStep(2)"
              >
                <div class="bank-choice-item-n withdrawWalletCard bank-choice">
                  <img :src="$getThemeImagePath('electron-gold.svg')" alt="">
                  <div class="bank-choice-text">
                    <div>{{ $t('Bao.e_wallet') }}</div>
                    <p class="describe-n">
                      {{ $t('Bao.e-payment') }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                v-if="availableWithdrawalTypes[1]"
                :class="{ 'channel-bank-cards-on': withdrawType === 1, 'channel-bank-cards': withdrawType !== 1 }"
                @click="goNextStep(1)"
              >
                <div class="bank-choice-item-n withdrawWalletCard bank-choice">
                  <img :src="$getThemeImagePath('bankB-gold.svg')" alt="">
                  <div class="bank-choice-text">
                    <div>{{ $t('Bao.bank_card_2') }}</div>
                  </div>
                </div>
              </div>

              <div
                v-if="availableWithdrawalTypes[3]"
                :class="{ 'channel-bank-cards-on': withdrawType === 3, 'channel-bank-cards': withdrawType !== 3 }"
                @click="goNextStep(3)"
              >
                <div class="bank-choice-item-n withdrawWalletCard bank-choice">
                  <img :src="$getThemeImagePath('bitcoin-btc-gold.svg')" alt="">
                  <div class="bank-choice-text">
                    <div>{{ $t('Bao.cryptocurrency_for_withdrawal') }}</div>
                    <p class="describe-n">
                      {{ $t('Bao.bitcoin_ethereum') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="slider">
              <form class="row-frame dep-form-frame gx-3 form-row-gap">
                <!-- pc 選錢包 -->
                <template v-if="withdrawType !== 3">
                  <div class="colu colu-12">
                    <label class="colu-12 for-label" for="ウォレット">
                      {{ $t('Bao.withdrawal_wallet') }}
                    </label>
                    <select
                      id="ウォレット"
                      v-model="selectedWalletKey"
                      class="for-select inpType icon-select"
                      @change="handleWalletChange"
                    >
                      <option
                        v-for="wallet in filteredWallets"
                        :key="wallet.key"
                        :value="wallet.key"
                      >
                        {{ getWalletName(wallet.wallet_type) }}
                      </option>
                    </select>
                  </div>
                  <div class="colu-12">
                    <label class="colu-12 for-label" for="カード/口座">
                      {{ $t('Bao.card_or_address') }}
                    </label>
                    <div class="row-frame">
                      <div class="colu colu-9 fun-withdraw-bank">
                        <select
                          id="カード/口座"
                          v-model="postForm.member_bank_id"
                          class="for-select inpType icon-select"
                          @change="selectBank"
                        >
                          <option :value="selectedBankName">
                            {{ selectedBankName }}
                          </option>
                          <template v-for="(bank, key) in myBanks">
                            <option
                              v-if="bank.bank_type === withdrawType"
                              :key="key"
                              :value="bank.id"
                            >
                              {{ bank.card_number }}
                            </option>
                          </template>
                        </select>
                      </div>

                      <div class="colu colu-3 fun-withdraw-bank">
                        <button class="btn button-style btn-creat" @click.prevent="$router.push('/user/bank')">
                          <img :src="$getThemeImagePath('add.svg')" alt="">{{ $t('Bao.new_bank_card') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- pc 加密貨幣: 錢包＋鏈 -->
                <template v-else>
                  <div class="colu colu-md-6 fun-withdraw-crypto">
                    <div class="colu-12 for-label" for="">
                      <span v-if="!isCryptoSelect && withdrawType === 3">
                        {{ $t('Bao.withdrawal_source') }}
                      </span>
                      <span v-else>
                        {{ $t('Bao.withdrawal_currency') }}
                      </span>
                    </div>
                    <div class="ch-crypto-form">
                      <div class="form-input-n2">
                        <div class="crypto-select-frame">
                          <div class="lang-select">
                            <button class="btn-select" @click.prevent="toggleDropdown">
                              <li v-if="selectedCoin && isCryptoSelect">
                                <img :src="$getThemeImagePath(`crypto-${selectedCoin.symbol.toLowerCase()}.svg`)" alt="">
                                <div class="affiliateWallet">
                                  <div class="coin">
                                    {{ selectedCoin.symbol }}
                                  </div>
                                  <div class="wallet">
                                    {{ selectedCoin.balance }}
                                  </div>
                                </div>
                              </li>
                              <li v-if="!isCryptoSelect && withdrawType === 3">
                                <img :src="getWalletImagePath(mainWallet)" alt="">
                                <div class="affiliateWallet">
                                  <div class="coin">
                                    {{ mainWallet.currency }}
                                  </div>
                                </div>
                              </li>
                            </button>
                            <div class="b" :class="{ active: isOpen }">
                              <ul class="crypto-list">
                                <li v-for="coin in coinList" :key="coin.coinId" @click="selectCrypto(coin)">
                                  <img :src="$getThemeImagePath(`crypto-${coin.symbol.toLowerCase()}.svg`)" alt="">
                                  <div class="affiliateWallet">
                                    <div class="coin">
                                      {{ coin.symbol }}
                                    </div>
                                    <div class="wallet">
                                      {{ coin.balance }}
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="colu colu-md-6 flex-colu fun-withdraw-crypto">
                    <label class="colu-12 for-label" for="ネットワークを選択">
                      <span v-if="!isCryptoSelect && withdrawType === 3">
                        {{ $t('Bao.withdrawal_target') }}
                      </span>
                      <span v-else>
                        {{ $t('Bao.withdrawal_chain') }}
                      </span>
                    </label>
                    <select
                      id="ネットワークを選択"
                      v-model="selectedChain"
                      class="for-select inpType icon-select"
                      @change="handleCryptoChange"
                    >
                      <option v-for="(chainObj, index) in chainList" :key="index" :value="chainObj">
                        {{ chainObj.chain }}
                      </option>
                    </select>
                  </div>
                </template>

                <div class="colu-12">
                  <label class="colu-12 for-label" for="出金額を入力してください">
                    <span v-if="!isCryptoSelect && withdrawType === 3">
                      {{ $t('Bao.please_enter_purchase_amount') }}
                    </span>
                    <span v-else>
                      {{ $t('Bao.please_enter_withdrawal_amount') }}
                    </span>
                  </label>

                  <div class="row-frame">
                    <div class="colu colu-9">
                      <input
                        id="出金額を入力してください"
                        v-model="postForm.amount"
                        class="for-input inpType"
                        type="text"
                        :placeholder="$t('Bao.input_withdrawal_amount')"
                        autocomplete="off"
                        @input="handleInput"
                        @keypress="onlyNumbers"
                      >
                    </div>

                    <div class="colu colu-3">
                      <button class="btn button-style btn-creat" @click.prevent="setAllAmount()">
                        {{ $t('Bao.withdrawal_all') }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="colu colu-12">
                  <template v-if="selectedBankTypeCode === 'JetonPay'">
                    <label class="colu-12 for-label" for="withdraw-amount">
                      {{ $t('Bao.jeton_account') }}
                    </label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.uid"
                        class="for-input inpType"
                        type="text"
                        :placeholder="$t('Bao.jeton_account')"
                        autocomplete="off"
                        @input="checkJetonErrors"
                      >
                    </div>
                    <div v-for="error in jetonErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                  </template>

                  <template v-if="selectedBankTypeCode === 'VegaWallet'">
                    <label class="colu-12 for-label" for="withdraw-amount">{{ $t('Bao.deposit_account') }}</label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.uid"
                        class="for-input inpType"
                        type="text"
                        :placeholder="$t('Bao.deposit_account')"
                        autocomplete="off"
                        @input="checkAccountErrors"
                      >
                    </div>
                    <div v-for="error in accountErrors" :key="error" class="help-block">
                      {{ error }}
                    </div>
                    <label class="colu-12 for-label" for="withdraw-amount">
                      {{ $t('Bao.deposit_password') }}
                    </label>
                    <div class="wallet-amount-frame">
                      <input
                        v-model="withdrawal_info.password"
                        v-validate="'required'"
                        class="for-input inpType"
                        type="password"
                        name="password"
                        :placeholder="$t('Bao.deposit_password')"
                        autocomplete="off"
                      >
                    </div>
                    <div v-if="errors.has('password')" class="help-block">
                      {{ $t("Bao.deposit_password_error") }}
                    </div>
                  </template>

                  <div class="withdraw-detail-frame">
                    <div class="detailList">
                      <b class="wDtitle">{{ $t('Bao.withdraw_limit') }}</b>
                      <span class="wDamount">{{ withdrawalLimit }}</span>
                    </div>
                    <div class="detailList">
                      <b class="wDtitle">{{ $t('Bao.withdrawal_amount_tip_line_2') }}</b>
                      <span class="wDamount">
                        <template v-if="withdrawType !== 3 || (!isCryptoSelect && withdrawType === 3)">{{ brand.currency }} </template>
                        {{ amount_limit }}
                      </span>
                    </div>
                  </div>
                </div>

                <div v-if="withdrawType === 3" v-show="isCryptoSelect && withdrawType === 3" class="colu-12">
                  <label class="colu-12 for-label" for="withdraw-amount">
                    {{ $t('Bao.withdrawal_address') }}
                  </label>
                  <div class="wallet-amount-frame">
                    <input
                      v-model="postForm.address"
                      v-validate="'required'"
                      class="for-input inpType"
                      :class="{ 'isInvalid': errors.has('address') }"
                      type="text"
                      :placeholder="$t('Bao.withdrawal_address')"
                      autocomplete="off"
                      name="address"
                    >
                  </div>
                  <div v-if="errors.has('address')" class="input-feedback text-align-R">
                    {{ $t('Bao.wallet_address_error') }}
                  </div>
                </div>

                <div v-if="selectedChain && selectedChain.supportMemo" class="colu-12">
                  <label class="colu-12 for-label colu-mr-t">{{ $t("Bao.destination_tag") }}</label>
                  <div class=" inp-relative">
                    <input
                      id="入金アドレス"
                      v-model="memo"
                      autocomplete="off"
                      class=" for-input inpType fs-14-w-700"
                      :placeholder="$t('Bao.destination_tag')"
                      type="text"
                    >
                    <button class="btn btn-keyChainCopy" @click.prevent="copyText(memo)" />
                  </div>
                  <div class="input-feedback remarks">
                    <div class="row-frame">
                      <div class="colu-auto icon-pr-1">
                        <i class="icon-alert ">
                          <img :src="$getThemeImagePath('icon_alert.png')" alt="">
                        </i>
                      </div>
                      <div class="colu-11 fs-14px pl-0 fs-remarks-box">
                        {{ $t("Bao.destination_tag_describe") }}
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="!google_auth_totp_status" class="colu colu-12">
                  <label class="colu-12 for-label" for="inputPassword">{{ $t("Bao.withdrawal_password") }}</label>
                  <input
                    id="inputPassword"
                    v-model="postForm.withdrawal_pass"
                    class="for-input inpType"
                    type="password"
                    :placeholder="$t('Bao.withdrawal_password_default')"
                    autocomplete="off"
                  >
                </div>
                <div v-if="google_auth_totp_status" class="colu colu-12">
                  <label class="colu-12 for-label" for="inputPassword">{{ $t("Bao.google_auth_verification") }}</label>
                  <input
                    id="inputPassword"
                    v-model="postForm.opt_code"
                    class="for-input inpType"
                    type="password"
                    :placeholder="$t('Bao.google_auth_default_verification')"
                    autocomplete="off"
                  >
                </div>

                <div class="withdraw-detail-frame">
                  <div class="detailList">
                    <b class="wDtitle">
                      <span v-if="!isCryptoSelect && withdrawType === 3">
                        {{ purchaseCryptoText }}
                      </span>
                      <span v-else>
                        {{ $t('Bao.total_amount') }}
                      </span>
                    </b>
                    <span class="wDamount">
                      <template v-if="withdrawType !== 3">{{ brand.currency }} </template>
                      <span v-if="!isCryptoSelect && withdrawType === 3">
                        {{ transferValue }}
                      </span>
                      <span v-else>
                        {{ postForm.amount > 0 ? postForm.amount : 0 | numberFormat }}
                      </span>
                    </span>
                  </div>
                  <div class="detailList">
                    <b class="wDtitle">{{ $t('Bao.residual_bonus') }}</b>
                    <span class="wDamount">{{ brand.currency }} {{ bonusGold | numberFormat }}</span>
                  </div>
                </div>

                <div class="form-check">
                  <div class="checkbox-wrapper-40">
                    <label>
                      <input
                        id="CheckDefault"
                        v-model="agree"
                        type="checkbox"
                        value=""
                      >
                      <span class="checkboxContent">
                        {{ $t('Bao.agree_delete_bonus_tips') }}
                      </span>
                    </label>
                  </div>
                </div>

                <div
                  class="button-style-w100 btn-primary"
                  :class="{ disabled: !checkInput() }"
                  type="submit"
                  @click="!isCryptoSelect && withdrawType === 3 ? sendTransfer() : checkIsWithdraw()"
                >
                  {{ $t('Bao.send') }}
                </div>
                <div v-if="isThemeGold" @click="$router.push('/page/support')">
                  <a class="help-deposit-n"><span class="icon-help">?</span>
                    <span class="help-text"> {{ $t('Bao.withdrawal_description') }}</span></a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showModel" class="popup-wrap text-center" :class="{ active: showModel }">
      <div class="popup-box">
        <div class="popup-success">
          <h5>
            {{ handleWithdrawText }}
          </h5>
          <button class="button-style-5" @click="doWithdrawal">
            <span>{{ $t('Bao.submit') }}</span>
          </button>
          <button class="button-style-5" @click="hideModel">
            <span>{{ $t('Bao.cancel') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { withdrawalCheck, withdrawalWallet, withdrawalPayment, getCoinlist, walletTransferRate, walletTransfer } from '@/api/payment'
import { getMyBanks } from '@/api/bank'
import { info } from '@/api/user'
import { showNotice, setErrorMessage, copyText, performKYCCheck, getWalletImagePath } from '@/utils/tool'
import crypto from 'crypto-js'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      withdrawType: '', // 1:銀行卡, 2:電子錢包, 3:虛擬貨幣
      myBanks: [],
      selectedBankName: this.$t('Bao.select_bankcard'),
      selectedBankTypeCode: '',
      wallets: [],
      selectedWallet: null,
      withdrawalCheck: {
        'amount': null,
        'withdrawal_fee': null,
        'actual_amount': null,
        'status': null,
        'require_performance': null,
        'performance_need': null,
        'current_performance': null
      },
      agree: false,
      postForm: {
        wallet_type: 'main',
        amount: '',
        withdrawal_pass: null,
        member_bank_id: this.$t('Bao.select_bankcard'),
        address: null
      },
      withdrawal_info: {},
      accountErrors: [' '],
      jetonErrors: [' '],
      isElectronActive: false,
      isBankActive: false,
      isBitcoinActive: false,
      showModel: false,
      availableWithdrawalTypes: {
        1: false, // bank card
        2: false, // e-wallet
        3: true // cryptocurrency
      },
      isMainWallet: true,
      isCryptoSelect: true,
      isOpen: false,
      coinList: [],
      chainList: [],
      mainWallet: null,
      selectedCoin: null,
      selectedChain: null,
      selectedWalletKey: null,
      memo: '',
      loadCoinApi: false,
      isWithdraw: true,
      JPchainList: [
        { chain: 'USDT', supportMemo: false },
        { chain: 'XRP', supportMemo: false },
        { chain: 'LTC', supportMemo: false }
      ],
      transRateList: [],
      transferValue: 0,
      rateJPtoUSDT: 0,
      activeJPtoUSDT: '',
      rateUSDTtoOther: 0,
      activeUSDTtoOther: '',
      transferPostForm: {
        fromWallet: 'main',
        toWallet: 'USDT',
        amount: 0
      },
      isNoClickEnter: true,
      isWithdrawalFull: false,
      fullAmount: 0
    }
  },
  computed: {
    ...mapGetters(['currentTheme', 'memberInfo', 'brand', 'brandInfo', 'bonusGold', 'user', 'permissionInfo', 'app']),
    before_withdrawal_module_setting() {
      return this.brandInfo.before_withdrawal_module_setting
    },
    isThemeGold() {
      return this.currentTheme === 'theme_gold'
    },
    isThemePurple() {
      return this.currentTheme === 'theme_purple'
    },
    max_withdrawal_amount() {
      return this.before_withdrawal_module_setting ? this.before_withdrawal_module_setting.max_withdrawal_amount : 0
    },
    handleWithdrawText() {
      return this.$t('Bao.is_handle_withdraw', { limit: this.max_withdrawal_amount })
    },
    purchaseCryptoText() {
      return this.$t('Bao.purchase_crypto', { crypto: this.transferPostForm.toWallet })
    },
    first_deposit_at() {
      return this.memberInfo.first_deposit_at
    },
    withdrawalLimit() {
      const wallet = (!this.isCryptoSelect && this.withdrawType === 3) ? this.mainWallet : this.selectedWallet

      if (wallet && wallet.withdrawal_limit && this.filteredWallets.length > 0) {
        const limit = parseFloat(wallet.withdrawal_limit) - parseFloat(wallet.turnover)

        return limit > 0 ? Math.floor(limit * 1e6) / 1e6 : 0
      }

      return 0
    },
    google_auth_totp_status() {
      // 會員開啟且後台也開啟，才要送 Google Auth 驗證碼
      return this.user.authStatus && this.permissionInfo.enable_google_totp
    },
    filteredWallets() {
      const hasCrypto = this.availableWithdrawalTypes[3]
      const hasNonCrypto = this.availableWithdrawalTypes[1] || this.availableWithdrawalTypes[2]
      let result = []
      if (this.withdrawType === 3) {
        result = this.wallets.filter(wallet => wallet.key !== 'main' && wallet.key !== 'commission')
      } else if (this.withdrawType === 1 || this.withdrawType === 2) {
        result = this.wallets.filter(wallet => wallet.key === 'main' || wallet.key === 'commission')
      } else {
        if (hasCrypto && hasNonCrypto) {
          // 三種都啟用 → 顯示全部
          result = this.wallets
        } else if (hasCrypto) {
          // 只有加密錢包
          result = this.wallets.filter(wallet => wallet.key !== 'main' && wallet.key !== 'commission')
        } else if (hasNonCrypto) {
          // 只有非加密錢包
          result = this.wallets.filter(wallet => wallet.key === 'main' || wallet.key === 'commission')
        }
      }

      const sortOrder = ['main', 'bonus', 'commission']
      return result.slice().sort((a, b) => {
        const aIndex = sortOrder.indexOf(a.key)
        const bIndex = sortOrder.indexOf(b.key)

        // 未列在 sortOrder 內的錢包，排在後面
        return (aIndex === -1 ? sortOrder.length : aIndex) - (bIndex === -1 ? sortOrder.length : bIndex)
      })
    },
    amount_limit() {
      const wallet = (!this.isCryptoSelect && this.withdrawType === 3) ? this.mainWallet : this.selectedWallet
      if (wallet && wallet.amount_limit && this.filteredWallets.length > 0) {
        if (wallet.name === 'main' || wallet.name === 'commission') {
          return parseInt(wallet.amount_limit.max)
        } else {
          const maxAmount = Number(wallet.amount_limit.max)
          return Math.floor(maxAmount * 1e6) / 1e6
        }
      } else if (wallet && wallet.symbol) {
        const cryptoWallet = this.wallets.find(item => item.name === wallet.symbol)
        const maxAmount = Number(cryptoWallet.amount_limit.max)
        const limit = Math.floor(maxAmount * 1e6) / 1e6
        return limit > 0 ? limit : 0
      }
      if (!this.isCryptoSelect && this.withdrawType === 3) {
        return parseInt(wallet.balance)
      }
      return 0
    }
  },
  watch: {
    filteredWallets(newList) {
      if (newList.length === 0) {
        this.selectedWallet = null
        this.postForm.wallet_type = null
      } else {
        if (this.withdrawType === 1 || this.withdrawType === 2) {
          if (this.isMainWallet) {
            this.postForm.wallet_type = 'main'
            this.selectedWallet = this.getWalletByKey('main')
            this.selectedWalletKey = 'main'
          } else {
            this.postForm.wallet_type = 'commission'
            this.selectedWallet = this.getWalletByKey('commission')
            this.selectedWalletKey = 'commission'
          }
        }
      }
    },
    selectedCoin: {
      handler(newCoin) {
        if (newCoin && newCoin.networks) {
          this.chainList = Object.values(newCoin.networks).map(network => ({
            chain: network.chain,
            supportMemo: network.supportMemo
          }))

          this.selectedChain = this.chainList[0] || null
          this.selectedWallet = newCoin
          this.postForm.wallet_type = newCoin.symbol
        } else {
          this.chainList = []
          this.selectedChain = null
        }
      },
      immediate: true
    }
  },
  created() {
    if (this.memberInfo.member_type === 3 && this.memberInfo.withdrawal_pass === '') {
      this.$router.push('/user/edit') // 是lite player
    }

    if (localStorage.getItem('fromPersonalToWithdrawal')) {
      localStorage.removeItem('fromPersonalToWithdrawal')
      this.postForm.wallet_type = 'commission'
      this.isMainWallet = false
    }

    const selectedWallet = this.app.selectedWallet
    if (selectedWallet.wallet_type === 'main') {
      this.isCryptoSelect = false
      this.mainWallet = selectedWallet
    }
    if (!selectedWallet || Object.keys(selectedWallet).length === 0 ||
        selectedWallet.wallet_type === 'main' || selectedWallet.wallet_type === 'commission' || selectedWallet.wallet_type === 'bonus') {
      this.withdrawType = 2
      this.isElectronActive = true
    } else {
      this.withdrawType = 3
      this.isBitcoinActive = true
      this.loadCoinList()
    }

    if (!this.isCryptoSelect) {
      walletTransferRate().then((response) => {
        this.transRateList = response.data.data.rate
        const matched = this.transRateList.find(item => item.fromCurrency === 'JPY' && item.toCurrency === 'USDT')
        const rateInfo = matched.rateInfo
        const matchedRateUSD = rateInfo.find(item => item.memo === 'USD轉為JPY的匯率')
        const matchedRateUSDT = rateInfo.find(item => item.memo === 'USDT轉為USDT的匯率')

        this.rateJPtoUSDT = matchedRateUSD.rate
        this.activeJPtoUSDT = matchedRateUSD.action
        this.rateUSDTtoOther = matchedRateUSDT.rate
        this.activeUSDTtoOther = matchedRateUSDT.action
      }).catch((error) => {
        setErrorMessage(error.response, this.errors)
      })
    }

    withdrawalWallet().then((response) => {
      this.wallets = response.data.data
      this.selectedWallet = this.getWalletByKey('main')
      this.selectedWalletKey = 'main'
    }).catch((error) => {
      const result = error.response.data
      if (result.status === 403) {
        showNotice(result.msg, () => {
          this.$router.push('/')
        })
      } else {
        if (!(result.data.type === 'bank_card' && this.isThemePurple)) {
          showNotice(result.msg, () => {}, true, false, '')
        }
        if (result.data.type === 'info') {
          this.$router.push({ path: '/user/edit' }).catch(() => {
          })
        } else if (result.data.type === 'bank_card' && !this.isThemePurple) {
          this.$router.push({ path: '/user/bank/create' }).catch(() => {
          })
        }
      }
    })

    getMyBanks().then((response) => {
      this.myBanks = response.data.data
      this.checkAvailableWithdrawalTypes()
    }).catch((error) => {
      setErrorMessage(error.response, this.errors)
    })

    if (this.withdrawalLimit !== 0 && this.postForm.wallet_type === 'main') {
      showNotice(this.$t('Bao.no_withdrawal_limit', { limit: this.withdrawalLimit }))
    }

    if (this.first_deposit_at === 0) {
      info().then(response => {
        const reqData = response.data
        this.$store.dispatch('SetUserData', reqData.data)
      })
    }
  },
  methods: {
    getWalletName(walletType) {
      switch (walletType) {
        case 'main':
          return this.$t('Bao.main_wallet')
        case 'commission':
          return this.$t('Bao.commission_wallet')
        default:
          return walletType
      }
    },
    hideModel() {
      this.showModel = false
    },
    checkIsWithdraw() {
      if (this.postForm.amount <= 0 || isNaN(this.postForm.amount)) {
        showNotice(this.$t('Bao.withdrawal_amount') + ' ' + this.$t('Bao.need_over_zero'))
        return false
      }

      if (this.postForm.wallet_type !== 'commission') {
        if (this.first_deposit_at === 0 && this.before_withdrawal_module_setting !== null) {
          if (this.postForm.amount > this.max_withdrawal_amount) {
            this.postForm.amount = this.max_withdrawal_amount
          }

          this.showModel = true
        } else {
          this.doWithdrawal()
        }
      } else {
        this.doWithdrawal()
      }
    },
    selectBank(event) {
      const selectedBankId = event.target.value
      const selectedBankType = this.myBanks.find(bank => bank.id.toString() === selectedBankId.toString())
      this.withdrawal_info = {}
      this.selectedBankTypeCode = selectedBankType.code
    },
    getWalletByKey(key) {
      const wallet = this.wallets.find(wallet => wallet.key === key)
      if (!wallet) return {}

      const matchInfo = this.user.walletInfo.find(info => info.wallet_type === wallet.wallet_type)
      return {
        ...wallet,
        withdrawal_limit: matchInfo ? matchInfo.withdrawal_limit : null,
        turnover: matchInfo ? matchInfo.turnover : 0
      }
    },
    handleCryptoChange() {
      this.transferPostForm.toWallet = this.selectedChain.chain
      const matched = this.transRateList.find(item => item.fromCurrency === 'JPY' && item.toCurrency === this.selectedChain.chain)
      const rateInfo = matched.rateInfo

      const matchedRateUSD = rateInfo.find(item => item.memo === 'USD轉為JPY的匯率')
      this.rateJPtoUSDT = matchedRateUSD.rate
      this.activeJPtoUSDT = matchedRateUSD.action

      const matchedRateOther = rateInfo.find(item => item.memo === 'USDT轉為' + this.selectedChain.chain + '的匯率')
      this.rateUSDTtoOther = matchedRateOther.rate
      this.activeUSDTtoOther = matchedRateOther.action
    },
    handleWalletChange() {
      const selected = this.filteredWallets.find(
        wallet => wallet.key === this.selectedWalletKey
      )

      this.selectedWallet = this.getWalletByKey(selected.wallet_type)
      this.postForm.wallet_type = selected.key
    },
    setAllAmount() {
      if (!this.selectedWallet) {
        this.postForm.amount = 0
        return
      }

      if (this.selectedWallet.wallet_type === 'main' || this.selectedWallet.wallet_type === 'commission') {
        this.postForm.amount = parseInt(this.selectedWallet['amount_limit'].max)
      } else {
        this.isWithdrawalFull = true
        const cryptoWallet = this.wallets.find(item => item.name === this.selectedWallet.symbol)
        this.fullAmount = Number(cryptoWallet.amount_limit.max) // 實際送給server的最大值
        const limit = Math.floor(this.fullAmount * 1e6) / 1e6
        this.postForm.amount = limit > 0 ? limit : 0 // 前端顯示的
      }
    },
    checkInput() {
      const hasWallet = !!this.selectedWallet
      const amountValid = this.postForm.amount !== '' && !isNaN(this.postForm.amount)
      const addressValid = !!this.postForm.address
      const chainValid = !!this.selectedChain
      const coinValid = !!this.selectedCoin
      const memoValid = !!this.memo
      const bankSelected = !isNaN(this.postForm.member_bank_id)
      const hasAgreed = this.agree

      // !!用來判斷是不是存在（不是 null、undefined、0、空字串等假值），並把它轉成布林值
      const passedAuth = this.google_auth_totp_status
        ? !!this.postForm.opt_code
        : !!this.postForm.withdrawal_pass

      const isJetonInvalid = this.selectedBankTypeCode === 'JetonPay' && this.jetonErrors.length > 0
      const isVegaInvalid = this.selectedBankTypeCode === 'VegaWallet' &&
                        (!this.withdrawal_info.password || this.accountErrors.length > 0)
      if (this.withdrawType === 3 && !this.isCryptoSelect) {
        this.getTransferValue()
        return amountValid && hasWallet && this.isWithdraw && hasAgreed && passedAuth
      } else {
        return amountValid && hasWallet && this.isWithdraw &&
        (this.withdrawType === 3 ? true : bankSelected) && // 非加密貨幣時檢查銀行選擇
        (this.withdrawType === 3 ? addressValid : true) && // 加密貨幣時檢查地址
        (this.withdrawType === 3 ? chainValid : true) &&
        (this.withdrawType === 3 ? coinValid : true) &&
        (this.withdrawType === 3 && this.selectedChain.supportMemo ? memoValid : true) &&
        hasAgreed && passedAuth && !isJetonInvalid && !isVegaInvalid
      }
    },
    doWithdrawal() {
      this.showModel = false

      const self = this
      const withdrawAmount = this.isWithdrawalFull ? this.fullAmount : this.postForm.amount
      withdrawalCheck({ amount: withdrawAmount, wallet_type: this.postForm.wallet_type }).then((response) => {
        if (response.data.data.status === 'deny') {
          showNotice(response.data.data.message)
        } else {
          this.withdrawalCheck = response.data.data
        }
      }).catch(() => {
        console.log('Cannot get wallet type')
      })

      if (this.withdrawType === 3) {
        this.postForm.chain = this.selectedChain.chain
        this.postForm.member_bank_id = null

        if (this.selectedChain.supportMemo) {
          this.postForm.memo = this.memo
        } else {
          this.postForm.memo = ' '
        }
      } else {
        this.postForm.address = null
        delete this.postForm.chain
        delete this.postForm.memo
      }

      const encryptedPostForm = { ...this.postForm }

      // 如果提款方式為 'VegaWallet',則加密密碼
      if (this.selectedBankTypeCode === 'VegaWallet') {
        encryptedPostForm.withdrawal_info = { ...this.withdrawal_info }
        encryptedPostForm.withdrawal_info.password = crypto.MD5(encryptedPostForm.withdrawal_info.password).toString()
      } else if (this.selectedBankTypeCode === 'JetonPay') {
        encryptedPostForm.withdrawal_info = { ...this.withdrawal_info }
      } else {
        // 其他提款方式,不需要帳號密碼
        delete encryptedPostForm.withdrawal_info
      }

      const encryptedOtherString = JSON.stringify(encryptedPostForm.withdrawal_info)

      withdrawalPayment({ ...encryptedPostForm, withdrawal_info: encryptedOtherString }).then((response) => {
        showNotice(response.data.msg, function() {
          self.$router.push({ path: '/user/transaction-history?type=withdrawRecord' })
        })
      }).catch((error) => {
        setErrorMessage(error.response, this.errors)
      })
    },
    goNextStep(type, typeName) {
      this.isNoClickEnter = false
      this.postForm.member_bank_id = this.$t('Bao.select_bankcard')
      this.withdrawType = type
      this.postForm.amount = 0
      this.memo = ''
      if (!this.isCryptoSelect && this.withdrawType === 3) {
        this.chainList = this.JPchainList
        this.selectedChain = this.chainList[0]
        this.transferPostForm.toWallet = this.selectedChain.chain
      }
      if (performKYCCheck(this.$router, this.withdrawType, false)) {
        this.isWithdraw = false
        return // 需要 KYC，已處理跳轉，不執行後續邏輯
      }

      this.isWithdraw = true

      if (type === 3 && this.selectCrypto) {
        if (!this.loadCoinApi) {
          this.loadCoinList()
        } else {
          this.selectedWallet = this.selectedCoin
          this.postForm.wallet_type = this.selectedCoin.symbol
        }
      }

      this.isElectronActive = typeName === 'electron' ? !this.isElectronActive : false
      this.isBankActive = typeName === 'bank' ? !this.isBankActive : false
      this.isBitcoinActive = typeName === 'bitcoin' ? !this.isBitcoinActive : false
    },
    formattedPrice(price) {
      return parseInt(price)
    },
    checkAccountErrors() {
      this.accountErrors = []
      if (!this.withdrawal_info.uid) {
        this.accountErrors.push(this.$t('Bao.deposit_account_error'))
      } else if (!/^[a-zA-Z]\d{6}$/.test(this.withdrawal_info.uid)) {
        this.accountErrors.push(this.$t('Bao.deposit_account_error'))
      }
    },
    checkJetonErrors() {
      this.jetonErrors = []
      if (!this.withdrawal_info.uid) {
        this.jetonErrors.push(this.$t('Bao.jeton_account_error'))
      } else if (!/^\d+$/.test(this.withdrawal_info.uid)) {
        this.jetonErrors.push(this.$t('Bao.jeton_account_error'))
      }
    },
    checkAvailableWithdrawalTypes() {
      this.availableWithdrawalTypes = {
        1: false,
        2: false,
        3: true
      }

      const banksByType = {}
      this.myBanks.forEach(bank => {
        if (!banksByType[bank.bank_type]) {
          banksByType[bank.bank_type] = []
        }
        banksByType[bank.bank_type].push(bank)
      })

      Object.entries(banksByType).forEach(([type, banks]) => {
        const hasAvailablePayments = banks.some(bank =>
          Array.isArray(bank.payments) && bank.payments.length > 0
        )

        if (hasAvailablePayments) {
          switch (parseInt(type)) {
            case 1:
              this.availableWithdrawalTypes[1] = true // Bank card
              break
            case 2:
              this.availableWithdrawalTypes[2] = true // E-wallet
              break
          }
        }
      })
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    selectCrypto(coin) {
      this.selectedCoin = coin
      this.isCryptoSelect = true
      this.isOpen = false
    },
    loadCoinList() {
      getCoinlist().then((response) => {
        this.coinList = response.data.data.filter(item =>
          this.filteredWallets.some(wallet => wallet.key === item.symbol)
        )
        if (this.isNoClickEnter) {
          this.selectedCoin = this.coinList.find(coin => coin.symbol === this.app.selectedWallet.wallet_type)
          this.selectCrypto(this.selectedCoin)
          this.isNoClickEnter = false
        }
        const walletInfo = this.user.walletInfo || []

        this.coinList = this.coinList.map(item => {
          const matchedWallet = walletInfo.find(w => w.wallet_type === item.symbol)
          const matchedFilteredWallet = this.filteredWallets.find(w => w.wallet_type === item.symbol)

          const balance = matchedWallet && matchedWallet.balance ? parseFloat(matchedWallet.balance) : 0
          const truncated = Math.floor(balance * 1e6) / 1e6

          return {
            ...item,
            balance: matchedWallet ? truncated.toFixed(6) : '0',
            withdrawal_limit: matchedWallet ? matchedWallet.withdrawal_limit : '0',
            turnover: matchedWallet ? matchedWallet.turnover : '0',
            amount_limit: matchedFilteredWallet ? matchedFilteredWallet.amount_limit : {}
          }
        })

        if (!this.isCryptoSelect) {
          return
        }
        const selectedWallet = this.app.selectedWallet
        if (!selectedWallet || Object.keys(selectedWallet).length === 0 || selectedWallet.wallet_type === 'main' || selectedWallet.wallet_type === 'commission' || selectedWallet.wallet_type === 'bonus') {
          this.selectedCoin = this.coinList[0]
        } else {
          this.selectedCoin = this.coinList.find(coin => coin.symbol === selectedWallet.wallet_type)
        }
        this.selectedWallet = this.selectedCoin
        this.postForm.wallet_type = this.selectedCoin.symbol

        this.loadCoinApi = true
      }).catch((error) => {
        console.error('loadCoinList 發生錯誤：', error)
        setErrorMessage(error.response, this.errors)
      })
    },
    copyText(msg) {
      copyText(msg, this.memo)
    },
    handleInput(event) {
      // 只保留數字
      const wallet = this.selectedWallet
      if (wallet) {
        if (wallet.name === 'main' || wallet.name === 'commission') {
          this.isWithdrawalFull = false
          const value = event.target.value.replace(/[^\d]/g, '')
          this.postForm.amount = value
        }
      }
    },
    getTransferValue() {
      let transferValue = 0
      this.transferPostForm.amount = this.postForm.amount
      // JPY轉USD USDT再轉其他加密貨幣
      if (this.activeJPtoUSDT === 'multiply') {
        transferValue = this.postForm.amount * this.rateJPtoUSDT
      } else {
        transferValue = this.postForm.amount / this.rateJPtoUSDT
      }

      if (this.activeUSDTtoOther === 'multiply') {
        transferValue = transferValue * this.rateUSDTtoOther
      } else {
        transferValue = transferValue / this.rateUSDTtoOther
      }

      this.transferValue = Math.trunc(transferValue * 1e6) / 1e6
    },
    sendTransfer() {
      const self = this
      walletTransfer(this.transferPostForm).then((response) => {
        const code = Math.abs(response.data.data.code)
        if (code === 1) {
          showNotice(this.$t('Bao.withdrawal_transfer_success'), function() {
            self.$router.push({ path: '/user/transaction-history?type=other' })
          })
        } else {
          showNotice(this.$t('Bao.withdrawal_error_' + code), function() {

          })
        }
      }).catch((error) => {
        setErrorMessage(error.response, this.errors)
      })
    },
    onlyNumbers(event) {
      // 阻止非數字字符的輸入
      const wallet = this.selectedWallet
      if (wallet) {
        if (wallet.name === 'main' || wallet.name === 'commission') {
          if (!/[0-9]/.test(event.key) && !['Backspace', 'Delete', 'Tab', 'Enter'].includes(event.key)) {
            event.preventDefault()
          }
        }
      }
    },
    getWalletImagePath
  }
}
</script>

<style scoped>
.popup-success button.button-style-5 {
    margin-left: 10px;
}
</style>
